import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldHasMaxChars: DataFieldRuleValidator = {
	validate: ({ isImplicitlyRequired }, dataFieldType, dataFieldValue, ruleValue) => {
		if (dataFieldValue === null || dataFieldValue === undefined) {
			return !isImplicitlyRequired;
		}
		switch (dataFieldType) {
			case DataFieldType.URL:
			case DataFieldType.EMAIL:
			case DataFieldType.LONG_TEXT:
			case DataFieldType.TEXT:
			case DataFieldType.CRYPT:
			case DataFieldType.PHONE:
			case DataFieldType.NUMBER:
				return `${dataFieldValue}`.length <= (ruleValue as number);
		}
		return false;
	},

	getErrorMessage: ({ t }, _, __, ruleValue) => {
		return t("Field has maximum {{count}} characters", { count: ruleValue as number });
	},
};
